// feature collection slide js

document.addEventListener("DOMContentLoaded", function () {

  const sections = document.querySelectorAll('.feature_collection_slider');

  if (!sections.length) return;

  sections.forEach(section => {

    const slider = section.querySelector('.slider');
    const progressBar = section.querySelector('.slider-progress-bar');

    if (!slider || !progressBar) return;

    function updateProgress() {
      const maxScroll = slider.scrollWidth - slider.clientWidth;
      const currentScroll = slider.scrollLeft;

      if (maxScroll <= 0) {
        progressBar.style.width = "100%";
        return;
      }

      const percent = (currentScroll / maxScroll) * 100;
      progressBar.style.width = percent + "%";
    }

    // scroll tracking
    slider.addEventListener('scroll', updateProgress);

    // arrow buttons
    const buttons = section.querySelectorAll('.slider-button');

    buttons.forEach(btn => {
      btn.addEventListener('click', () => {
        setTimeout(updateProgress, 400);
      });
    });

    // init
    setTimeout(updateProgress, 300);

  });

});


// submit loader (this part is fine)
document.addEventListener("submit", function (e) {
  const btn = e.target.querySelector(".card-plus-btn");

  if (btn) {
    btn.classList.add("loading");
  }
});



// marque js
window.addEventListener('load', function () {
  const wrapper = document.getElementById('marquee-wrapper');
  const item = wrapper.innerHTML;
  wrapper.innerHTML = item.repeat(3);
  const finalContent = wrapper.innerHTML;
  wrapper.innerHTML = finalContent + finalContent;
  wrapper.style.animation = "scroll-loop 150s linear infinite";
});



// Collections All Tabs Filter

document.addEventListener('DOMContentLoaded', function () {

  const path = window.location.pathname;
  const isAllPage = path === '/collections/all';

  /* =========================
     GET URL PARAMS
  ========================= */
  const params = new URLSearchParams(window.location.search);
  let activeTab = params.get('tab');


  /* =========================
     FILTER PRODUCTS
  ========================= */
  function applyFilter(filter) {
    document.querySelectorAll('#product-grid .grid__item').forEach(item => {

      let collections = item.getAttribute('data-collections') || '';
      let arr = collections.trim().split(/\s+/);

      item.style.display = arr.includes(filter) ? '' : 'none';



// ✅ ADD THIS LINE
updateVisibleCount();

    });
  }

  /* =========================
     Visible Counts
  ========================= */

function updateVisibleCount() {
  const grid = document.getElementById('product-grid');
  const el = document.getElementById('visibleRange');

  if (!grid || !el) return;

  const totalProducts = parseInt(grid.dataset.totalProducts) || 0;
  const pageSize = parseInt(grid.dataset.pageSize) || 24;
  const currentPage = parseInt(grid.dataset.currentPage) || 1;

  // If total products are less than page size
  if (totalProducts <= pageSize) {
    el.textContent = `Showing ${totalProducts} of ${totalProducts} items`;
    return;
  }

  const start = ((currentPage - 1) * pageSize) + 1;
  const end = Math.min(currentPage * pageSize, totalProducts);

  el.textContent = `Showing ${start}–${end} of ${totalProducts} items`;
}

document.addEventListener('DOMContentLoaded', updateVisibleCount);


  /* =========================
     SET ACTIVE TAB UI
  ========================= */
  function setActiveTab(filter) {
    document.querySelectorAll('.tab_btn').forEach(btn => {
      btn.classList.remove('active');

      if (btn.dataset.filter === filter) {
        btn.classList.add('active');
      }
    });
  }


  /* =========================
     INIT TAB ON LOAD
  ========================= */
  function initTabs() {

    if (!isAllPage) return; // ONLY on /collections/all

    // if no tab → use first
    if (!activeTab) {
      let firstTab = document.querySelector('.tab_btn');
      if (firstTab) {
        activeTab = firstTab.dataset.filter;
      }
    }

    if (activeTab) {
      applyFilter(activeTab);
      setActiveTab(activeTab);
    }

  }

  if (!isAllPage) {
  document.querySelectorAll('.tab_btn').forEach(btn => {
    btn.style.pointerEvents = 'none';
    btn.style.opacity = '0.6'; // optional (looks disabled)
    btn.style.cursor = 'default';
  });
}

  /* =========================
     TAB CLICK
  ========================= */
  document.addEventListener('click', function (e) {

    const btn = e.target.closest('.tab_btn');
    if (!btn) return;

    const filter = btn.dataset.filter;

    // 👉 If not on /all → redirect clean
    if (!isAllPage) {
  return; // ❌ do nothing if not /collections/all
}

    applyFilter(filter);
setActiveTab(filter);
activeTab = filter; // ✅ ADD THIS

    // 👉 UPDATE URL (correct way)
    let params = new URLSearchParams(window.location.search);
    params.set('tab', filter);

    const newUrl = `${window.location.pathname}?${params.toString()}`;
    window.history.pushState({}, '', newUrl);

  });


  /* =========================
     SORTING (FIXED)
  ========================= */
  // const sort = document.getElementById('SortBy');

  // if (sort) {
  //   sort.addEventListener('change', function () {

  //     let params = new URLSearchParams(window.location.search);

  //     // set sorting
  //     params.set('sort_by', this.value);

  //     // KEEP tab if exists
  //     if (activeTab) {
  //       params.set('tab', activeTab);
  //     }

  //     // correct format: ?a=1&b=2
  //     window.location.search = params.toString();

  //   });
  // }


const sort = document.getElementById('SortBy');

if (sort) {
  sort.addEventListener('change', function () {

    let params = new URLSearchParams(window.location.search);

    // set sorting
    params.set('sort_by', this.value);

    // ✅ ALWAYS get current tab from URL (not variable)
    const currentTab = params.get('tab');
    if (currentTab) {
      params.set('tab', currentTab);
    }

    // update without losing tab
    const newUrl = window.location.pathname + '?' + params.toString();

    fetch(newUrl)
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        const newGrid = doc.querySelector('.product-grid');
        const currentGrid = document.querySelector('.product-grid');

        if (newGrid && currentGrid) {
  currentGrid.innerHTML = newGrid.innerHTML;

  // ✅ re-apply tab filter after DOM update
  const updatedParams = new URLSearchParams(newUrl.split('?')[1]);
  const currentTab = updatedParams.get('tab');

  if (currentTab) {
  applyFilter(currentTab);
  setActiveTab(currentTab);
  updateVisibleCount(); // ✅ ADD THIS
}
}

        // update URL without reload
        window.history.pushState({}, '', newUrl);
      })
      .catch(err => console.error(err));
  });
}





  /* =========================
     CLEAN URL ON OTHER COLLECTIONS
  ========================= */
  if (!isAllPage) {
    let url = new URL(window.location.href);

    if (url.searchParams.has('tab')) {
      url.searchParams.delete('tab');
      window.history.replaceState({}, '', url.pathname + url.search);
    }
  }


  /* =========================
     INIT
  ========================= */
  initTabs();
updateVisibleCount(); // ✅ ADD THIS

});



// testimonial js

 
jQuery(document).ready(function ($) {

  const $slider = $('.review_slider');

  // Prevent double initialization
  if ($slider.hasClass('slick-initialized')) {
    $slider.slick('unslick');
  }

  $slider.slick({
    autoplay: true,
    autoplaySpeed: 2500, // delay between slides (IMPORTANT: not 0)
    speed: 500, // transition speed
    cssEase: 'ease-in-out',
    centerMode: true,
    infinite: true,
    arrows: false,
    dots: false,

    pauseOnHover: true,
    pauseOnFocus: false,
    pauseOnDotsHover: true,

    slidesToShow: 3 ,
    slidesToScroll: 1,

    centerMode: true,
    centerPadding: '60px',

    swipeToSlide: true,
    touchMove: true,

    waitForAnimate: true,

    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          centerPadding: '40px'
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 1,
          centerPadding: '5px'
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '0px',
          autoplay: true,
          autoplaySpeed: 2500,
          speed: 500
        }
      }
    ]
  });

});

jQuery(document).ready(function ($) {
  $('.review_slider-1').slick({
    dots: false,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
  autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });
});


document.addEventListener("DOMContentLoaded", function () {

  // Close all by default
  document.querySelectorAll(".faq_content").forEach(c => {
    c.style.display = "none";
  });

  document.querySelectorAll(".faq_header").forEach(button => {

    button.addEventListener("click", function () {
      const content = this.nextElementSibling;
      const parent = this.parentElement;

      // If already active → close it
      if (this.classList.contains("active")) {
        this.classList.remove("active");
        parent.classList.remove("active");
        content.style.display = "none";
        return;
      }

      // Close all
      document.querySelectorAll(".faq_header").forEach(btn => {
        btn.classList.remove("active");
      });

      document.querySelectorAll(".faq_item").forEach(item => {
        item.classList.remove("active");
      });

      document.querySelectorAll(".faq_content").forEach(c => {
        c.style.display = "none";
      });

      // Open current
      this.classList.add("active");
      parent.classList.add("active");
      content.style.display = "block";
    });

  });
});




// // Related Product Slider
// document.addEventListener("DOMContentLoaded", function () {

//   const recommendations = document.querySelector('product-recommendations');

//   if (!recommendations) return;

//   const observer = new MutationObserver(() => {

//     const slider = recommendations.querySelector('.product-grid');
//     const progressBar = recommendations.querySelector('.related_progress_bar');

//     if (!slider || slider.classList.contains('slick-initialized')) return;

//     $(slider).slick({
//   slidesToShow: 3.5,
//   slidesToScroll: 1,
//   infinite: false,
//   arrows: true,
//   dots: false,

//   appendArrows: $('.related_slider_arrow'),

//   prevArrow: '<button class="slick-prev custom-arrow"><img src="https://cdn.shopify.com/s/files/1/0992/9614/9879/files/slider_arrow.png?v=1776410938" class="img-responsive"></button>',
//   nextArrow: '<button class="slick-next custom-arrow"><img src="https://cdn.shopify.com/s/files/1/0992/9614/9879/files/slider_arrow.png?v=1776410938" class="img-responsive"></button>',

//   responsive: [
//     {
//       breakpoint: 990,
//       settings: {
//         slidesToShow: 2
//       }
//     },
//     {
//       breakpoint: 767,
//       settings: {
//         slidesToShow: 1
//       }
//     }
//   ]
// });

//     function updateProgress(currentSlide, slick) {
//       const maxSteps = slick.slideCount - slick.options.slidesToShow;
//       const progress = maxSteps > 0 ? (currentSlide / maxSteps) * 100 : 100;
//       progressBar.style.width = progress + "%";
//     }

//     $(slider).on('init', function (event, slick) {
//       updateProgress(0, slick);
//     });

//     $(slider).on('afterChange', function (event, slick, currentSlide) {
//       updateProgress(currentSlide, slick);
//     });

//   });

//   observer.observe(recommendations, { childList: true, subtree: true });

// }); 


// // Related Slider Progress Bar
// document.addEventListener("DOMContentLoaded", () => {

// const section = document.querySelector('.related-products');
// if (!section) return;

// const slider = section.querySelector('.slider');
// const progressBar = section.querySelector('.related_progress_bar');
// if (!slider || !progressBar) return;

// /* RAF THROTTLE */
// let ticking = false;

// const updateProgress = () => {
// const maxScroll = slider.scrollWidth - slider.clientWidth;
// const percent = maxScroll > 0
// ? (slider.scrollLeft / maxScroll) * 100
// : 100;

// ```
// progressBar.style.width = percent + "%";
// ```

// };

// const onScroll = () => {
// if (!ticking) {
// requestAnimationFrame(() => {
// updateProgress();
// ticking = false;
// });
// ticking = true;
// }
// };

// /* SCROLL (OPTIMIZED) */
// slider.addEventListener('scroll', onScroll, { passive: true });

// /* BUTTON CLICK (NO TIMEOUT) */
// const buttons = section.querySelectorAll('.slider-button');

// buttons.forEach(btn => {
// btn.addEventListener('click', () => {
// requestAnimationFrame(updateProgress);
// });
// });

// /* INIT (NO TIMEOUT) */
// requestAnimationFrame(updateProgress);

// });



// about page counter
$('.counter').each(function () {
		var $this = $(this),
			countTo = parseInt($this.attr('data-count'));

		$({ countNum: 0 }).animate(
			{ countNum: countTo },
			{
				duration: 2000,
				easing: 'swing',
				step: function () {
					$this.text(Math.floor(this.countNum) + '+');
				},
				complete: function () {
					$this.text(this.countNum + '+');
				}
			}
		);
	});

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.collection_list_sec ul.collection-list > li').forEach(li => {
    const link = li.querySelector('a[href*="/collections/"]');

    if (!link) return;

    const handle = link
      .getAttribute('href')
      .replace('/collections/', '')
      .split('?')[0];

    li.classList.add(handle);
  });
});